class LedLightingToggle extends HTMLElement {
  connectedCallback() {
    this.section = this.dataset.section;
    // Free-promo mode is presentational only — the two-line add below is
    // unchanged; a Shopify automatic discount zeroes the LED line.
    this.free = this.dataset.free === 'true';
    // Size -> standalone "LED Lighting System" variant { id, cents }.
    this.map = JSON.parse(this.querySelector('.led-toggle__map').textContent);
    this.input = this.querySelector('.led-toggle__input');
    this.nowEl = this.querySelector('.led-toggle__price-now');
    // Struck-through standalone price under the net price (paid sizes).
    this.wasEl = this.querySelector('.led-toggle__price-was');
    // Struck-through net price beside "Free" (promo sizes; absent when no promo).
    this.struckEl = this.querySelector('.led-toggle__price-struck');
    this.form = document.getElementById('product-form-' + this.section);

    this._onToggle = () => this.classList.toggle('led-toggle--on', this.input.checked);
    this._onChange = (e) => {
      if (this.form && e.target !== this.input && e.target.form === this.form) this.renderPrice();
    };
    // Capture on document runs before product-form.js's target-phase submit
    // handler; stopPropagation() prevents its pergola-only add when LED is on.
    this._onSubmitCapture = (e) => this.onSubmitCapture(e);

    this.input.addEventListener('change', this._onToggle);
    document.addEventListener('change', this._onChange);
    document.addEventListener('submit', this._onSubmitCapture, true);
    this.renderPrice();
  }

  disconnectedCallback() {
    document.removeEventListener('change', this._onChange);
    document.removeEventListener('submit', this._onSubmitCapture, true);
  }

  field(name) {
    if (!this.form) return null;
    // Size/id inputs are linked via the form="" attribute, so they are not DOM
    // descendants — resolve through form.elements.
    return this.form.elements.namedItem(name) || this.form.elements.namedItem('options[' + name + ']');
  }

  sizeKey() {
    const f = this.field('Size');
    const label = f && f.value ? f.value : '';
    return label.replace(/['’′"\s]/g, '').toLowerCase();
  }

  entryForSize() {
    return this.map[this.sizeKey()] || null;
  }

  money(cents, prefix) {
    return prefix + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // A pre-order (out-of-stock) kit takes no automatic discount at all — not the
  // free-LED promo and not the standing $100 off — because BXGY discounts skip
  // selling-plan lines. So quote such a size at the full kit price and never
  // call it free; anything else undercuts what the customer is actually charged.
  renderPrice() {
    const e = this.entryForSize();
    if (!e) return;
    // Older cached markup has no "available" key — treat that as purchasable.
    const soldOut = e.available === false;
    this.classList.toggle('led-toggle--soldout', soldOut);
    this.input.disabled = soldOut;
    if (soldOut && this.input.checked) {
      this.input.checked = false;
      this._onToggle();
    }
    const discountable = !!e.discountable;
    // Older cached markup has no "free" key — that markup predates per-size
    // promos, so the promo then covers every size.
    const freeNow = this.free && e.free !== false && discountable && !soldOut;
    this.classList.toggle('led-toggle--free-size', freeNow);
    this.classList.toggle('led-toggle--preorder', !discountable && !soldOut);
    if (this.wasEl) this.wasEl.textContent = discountable && !soldOut ? this.money(e.cents, '$') : '';
    if (soldOut) {
      this.nowEl.textContent = 'Sold out';
      return;
    }
    const cents = discountable ? e.cents - 10000 : e.cents;
    this.nowEl.textContent = this.money(cents, '+ $');
    if (this.struckEl) this.struckEl.textContent = this.money(cents, '$');
  }

  onSubmitCapture(evt) {
    if (evt.target !== this.form) return;
    if (!this.input.checked) return; // pergola-only: let the normal submit proceed
    const led = this.entryForSize();
    if (!led) return; // unknown size: don't add a wrong LED; let normal submit proceed
    if (led.available === false) return; // sold-out kit: pergola-only submit
    evt.preventDefault();
    evt.stopPropagation();
    const idField = this.field('id');
    const pergolaId = idField && idField.value;
    if (!pergolaId) return;
    const body = { items: [
      { id: Number(pergolaId), quantity: 1 },
      { id: led.id, quantity: 1, properties: { _addon: 'led', _led_for: String(pergolaId) } }
    ]};
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    }).then((res) => {
      if (!res.ok) { return res.json().then((d) => { throw new Error(d && d.description || 'Add to cart failed'); }); }
      window.location = window.routes.cart_url;
    }).catch((err) => { console.error('LED add-on add to cart failed:', err); });
  }
}
customElements.define('led-lighting-toggle', LedLightingToggle);
